module.exports = __webpack_public_path__ + "static/media/current_iq.a09f5018.svg";